import React, {useState, useEffect, useRef} from "react";
import {injectIntl} from "react-intl";
import PropTypes from "prop-types";
import $ from "jquery";

import TextField from "@mui/material/TextField";

import {loadScript} from "../../../misc/loadScript";
import Config, {REACT_APP_GOOGLE_API_KEY} from "../../../config";
import {onInputBlur, onInputChange, useInputsValidation} from "./inputFunctions";

const googleComponentsToOurProperties = {
  "administrative_area_level_1": "state",
  "locality": "city",
  "postal_code": "postal",
  "country": "country",
}


const LookAddressInput = (props) => {

  const {property, inputValue, setInputValue, intl, errorsObject, changeErrorsObject, getValidationErrors, inputClassName,
    inputsValidated, isRequired, shrink, updateInputValidations, shouldSetCountry, blockClassName} = props;

  const [allowRef, setAllowRef] = useState(false);
  const autoCompleteRef = useRef(null);

  const onBlur = (event) => {
    onInputBlur(event, property, setInputValue, errorsObject, changeErrorsObject, getValidationErrors);
    // setTimeout(() => {
    //   setAllowRef(false); // blur the Mui input, so the google logic is hidden
    // }, 0)
  };

  const onChange = (event) => {
    onInputChange(event, property, setInputValue, errorsObject, changeErrorsObject, getValidationErrors);
  };

  useInputsValidation(inputsValidated, onBlur, inputValue);

  useEffect(() => {
    return () => {
      if (window.google && window.google.maps && window.google.maps.event) {
        window.autoComplete = null;
        const pacContainer = document.querySelector(".pac-container");
        if (pacContainer) {
          $(pacContainer).remove();
        }
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  const onFocus = () => {
    if (!allowRef) {
      setAllowRef(true);
      setTimeout(() => {
        handleScriptLoad();
      }, 0)
    }
  };

  const handlePlaceSelect = async () => {
    const addressObject = autoComplete.getPlace();
    if (!addressObject) {
      return
    }
    const {formatted_address, address_components} = addressObject;
    if (formatted_address) {
      const street_number = address_components.find(component => component.types.includes("street_number"));
      const route = address_components.find(component => component.types.includes("route"));
      const sublocality = address_components.find(component => {
        return ['sublocality_level_1', 'sublocality', 'political'].some(type => component.types.includes(type))
      });
      // '123 William St, New York, NY 10038, USA' -> '123 William St'
      let addressValue = street_number ? (street_number.short_name || "") : "";
      if (route) {
        addressValue += " " + (route.long_name || route.short_name);
      } else if (sublocality) {
        addressValue += " " + (sublocality.long_name || sublocality.short_name);
      }
      if (street_number && (route || sublocality) && addressValue) {
        onBlur({target: {value: addressValue.trim()}});
      } else {
        // ['administrative_area_level_1', 'political', 'country', 'political', 'postal_code'].forEach(type => {
        //   address_components.forEach(component => {
        //     if (component.types.includes(type)) {
        //       value = value
        //         .replace(", " + component.long_name, "")
        //         .replace(", " + component.short_name, "")
        //         .replace(" " + component.short_name, "")
        //         .replace(" " + component.short_name, "")
        //     }
        //   })
        // })
        onBlur({target: {value: formatted_address}});
      }
    }
    if (Config.isDevMode()) {
      console.log(addressObject);
    }
    if (!address_components) {
      return
    }
    Object.keys(googleComponentsToOurProperties).forEach(componentKey => { // here we also set another inputs values
      const component = address_components.find(component => component.types.includes(componentKey));
      if (component && (componentKey !== "country" || shouldSetCountry)) {
        const value = componentKey === "country"
          ? component.short_name || component.long_name
          : component.long_name || component.short_name;
        setInputValue(googleComponentsToOurProperties[componentKey], value);
        if (componentKey === "administrative_area_level_1" && component.short_name) {
          setInputValue("stateShort", component.short_name);
        } else if (componentKey === "postal_code" && updateInputValidations) {
          setTimeout(() => {
            updateInputValidations(); // after postal data is set
          }, 0)
        }
      }
    })
  }

  const handleScriptLoad = () => {
    if (window.google && window.google.maps && window.google.maps.places) {
      window.autoComplete = new window.google.maps.places.Autocomplete(
        autoCompleteRef.current,
        // { types: ["(cities)"], componentRestrictions: { country: "us" } }
      );
      window.autoComplete.setFields(["address_components", "formatted_address"]);
      window.autoComplete.addListener("place_changed", handlePlaceSelect);
    }
  }

  useEffect(() => {
    if (!document.getElementById("googleMapsScript")) {
      loadScript(
        `https://maps.googleapis.com/maps/api/js?key=${REACT_APP_GOOGLE_API_KEY}&libraries=places&callback=clearTimeout`,
        null,
        "googleMapsScript"
      );
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const errorsExist = errorsObject && Array.isArray(errorsObject[property]) && !!errorsObject[property].length;

  return (
    <div className={"look-block" + (blockClassName ? " " + blockClassName : "")}>
      <TextField className={"look-input " + (inputClassName ? " " + inputClassName : "")}
                 type={"text"}
                 inputRef={allowRef ? autoCompleteRef : null}
                 value={inputValue}
                 required={isRequired}
                 size="small"
                 name={property}
                 label={intl.formatMessage({id: "look.inputs.address1"})}
                 onBlur={onBlur}
                 onChange={onChange}
                 onFocus={onFocus}
                 error={errorsExist}
                 InputLabelProps={{shrink}}
                 helperText={
                   errorsExist ? intl.formatMessage({id: errorsObject[property][0]}) : ""
                 }
                 variant="outlined"/>
    </div>
  )
}

LookAddressInput.propTypes = {
  property: PropTypes.string.isRequired,
  setInputValue: PropTypes.func.isRequired,
  isRequired: PropTypes.bool,
  shouldSetCountry: PropTypes.bool, // for shipping only
  // validation below
  inputsValidated: PropTypes.bool,
  errorsObject: PropTypes.object, // userInfoErrorsLike
  changeErrorsObject: PropTypes.func,
  getValidationErrors: PropTypes.func,
  updateInputValidations: PropTypes.func,
  blockClassName: PropTypes.string,
  inputClassName: PropTypes.string,
};

export default injectIntl(LookAddressInput)
